var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [(_vm.notifyTitle) ? _c('div', {
    staticClass: "notify-container"
  }, [_c('div', {
    staticClass: "header-box"
  }, [_c('span', {
    staticClass: "notify-text"
  }, [_vm._v(_vm._s(_vm.notifyTitle))]), _vm._v(" "), _c('span', {
    staticClass: "notify-time"
  }, [_vm._v(_vm._s(_vm.notifyStartTime))])]), _vm._v(" "), _c('div', {
    staticClass: "content-box"
  }, [_c('div', {
    directives: [{
      name: "dompurify-html",
      rawName: "v-dompurify-html",
      value: (_vm.notifyContent),
      expression: "notifyContent"
    }],
    attrs: {
      "id": "notify-content"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "footer-box"
  }, [_c('span', {
    staticClass: "btn",
    on: {
      "click": _vm.cancelWait
    }
  }, [_vm._v("离开")]), _vm._v(" "), _c('div', {
    staticClass: "btn",
    class: [_vm.countDown !== 0 ? 'disable' : 'ok'],
    style: ({
      'background': _vm.countDown !== 0 ? '#ccc' : _vm.boxBodyColor
    }),
    on: {
      "click": _vm.jumpTo
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.countDown !== 0),
      expression: "countDown!==0"
    }]
  }, [_vm._v(_vm._s(_vm.countDown) + "s ")]), _vm._v(" "), _c('span', [_vm._v("进入")])])])]) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f5ce6202","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
// module id = QbQc
// module chunks = 1